import React from "react";
import Errors from "./Errors";

// 検索結果 リスト
const Results = (props) => {
    const { result } = props;//searchResultDataを元に表示
    let errorMsg2 = '';


    if(result.length === 0) {
        //初期状態(検索実行前)
    }else{
        if(result['status'] == 'error') {
            // error
            errorMsg2 = result['msg'];
            return (
                <Errors msg={errorMsg2} errorClass="error-msg" />
            );
        } else {
            // success
            if(result['item_count'] == 0){
                //検索結果 0件
                errorMsg2 = 'ご入力いただいた個体識別番号「' + result['cid'] + '」は登録されていません。';
                return (
                    <Errors msg={errorMsg2} errorClass="error-msg notfound" />
                );
            }else{
                //検索結果 1件以上存在
                return (
                    <div class="result-area">
                        <div class="result-header">
                            <p class="is-hide">「{result['cid']}」の検索結果: {result['item_count']}件</p>
                        </div>
                        <div class="result-container">
                        {result['items'].map((val, i) => {
                            return <Article key={i} value={val} />
                        })}
                        </div>
                    </div>
                );
            }
        }
    }

};

// 検索結果 各件ごとの表示
const Article = (props) => {
    const { value } = props;
    return (
        <div class="result-list">
            <div class="result-list-row">
                <div class="result-list-col">個体識別番号</div>
                <div class="result-list-col">{value['cattle_id']}</div>
            </div>
            <div class="result-list-row">
                <div class="result-list-col">検査結果</div>
                <div class="result-list-col">{value['cattle_dna']}</div>
            </div>
            <div class="result-list-row">
                <div class="result-list-col">検査機関</div>
                <div class="result-list-col">{value['cattle_lab']}</div>
            </div>
            <div class="result-list-row">
                <div class="result-list-col">検査日</div>
                <div class="result-list-col">{value['cattle_genetestdate']}</div>
            </div>
        </div>
    );
};
export default Results;